export default "__VITE_ASSET__DNof43p2__"